import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { GetSingleQuestion } from "../../../../APIs/Function/Workout/Q&A/GetSingleQuestion";
import { Box, Typography, CircularProgress } from "@mui/material";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";

const SingleQuestion = () => {
  const [singleQuestion, setSingleQuestion] = useState({});
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const handleSingleQuestion = async () => {
    try {
      setLoading(true);
      let res = await GetSingleQuestion(id);
      setSingleQuestion(res.r);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleSingleQuestion();
  }, []);

  return (
    <>
      <Box
        sx={{
          bgcolor: "#31AEF4",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: { xs: "50px", md: "70px", lg: "70px" },
          p: "10px",
          boxSizing: "border-box",
        }}
      >
        <Link to={"/questions"}>
          <Box
            sx={{
              height: { xs: "50px", md: "60px", lg: "60px" },
              display: "flex",
              alignItems: "center",
            }}
          >
            <img height={"100%"} src={backbluebtn} alt="back" />
          </Box>
        </Link>
        <Box>
          <Typography
            sx={{
              fontFamily: "Open Sans",
              fontSize: { md: "30px", sm: "20px" },
              fontWeight: 600,
              lineHeight: "36px",
              color: "#FFFFFF",
            }}
          >
            Question Details
          </Typography>
        </Box>
        <Box></Box>
      </Box>
      <Box sx={{ width: "50%", m: "auto", p: 5, boxSizing: "border-box" }}>
        <Box
          sx={{
            border: "1px solid #E8E8E8",
            mt: "10px",
            textAlign: "left",
            boxSizing: "border-box",
            p: "10px",
            borderRadius: "5px",
          }}
        >
          <Typography
            sx={{ fontFamily: "Open Sans", fontSize: "17px", color: "#737373" }}
          >
            Question
          </Typography>
          <Typography sx={{ fontFamily: "Open Sans", fontSize: "17px" }}>
            {singleQuestion.que}
          </Typography>
        </Box>
        {singleQuestion?.options?.map((e, i) => (
          <Box
            sx={{
              border: "1px solid #E8E8E8",
              mt: "10px",
              textAlign: "left",
              boxSizing: "border-box",
              p: "10px",
              borderRadius: "5px",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Open Sans",
                fontSize: "17px",
                color: "#737373",
              }}
            >
              Option{i + 1}
            </Typography>
            <Typography sx={{ fontFamily: "Open Sans", fontSize: "17px" }}>
              {e.options}
            </Typography>
          </Box>
        ))}
      </Box>
    </>
  );
};

export default SingleQuestion;
